import type { components } from "@farmacenter/api";
import { useApi } from "../../api/ApiProvider";
import { useOrg } from "../OrgContext";
import { SelectorBuscado } from "./SelectorBuscado";

export type ProductoBuscado = components["schemas"]["ProductSearchRepresentation"];

export interface SelectorProductoProps {
  label?: string | undefined;
  ocultarEtiqueta?: boolean | undefined;
  onSelect: (producto: ProductoBuscado | null) => void;
  autoFocus?: boolean | undefined;
  valorInicial?: string | undefined;
}

/** Escribe-y-busca un producto por nombre, SKU o código contra `searchProductCatalog`. */
export function SelectorProducto({
  label,
  ocultarEtiqueta,
  onSelect,
  autoFocus,
  valorInicial,
}: SelectorProductoProps) {
  const api = useApi();
  const { tenantId } = useOrg();
  return (
    <SelectorBuscado<ProductoBuscado>
      label={label ?? "Producto"}
      ocultarEtiqueta={ocultarEtiqueta}
      placeholder="Buscar por nombre, SKU o código…"
      clave={["buscar-productos", tenantId]}
      buscar={(texto) =>
        api.GET("/api/v1/tenants/{tenantId}/products/search", {
          params: { path: { tenantId }, query: { query: texto } },
        })
      }
      getKey={(p) => p.productId ?? ""}
      getLabel={(p) => p.name ?? "(sin nombre)"}
      getDetalle={(p) => p.sku ?? ""}
      onSelect={onSelect}
      autoFocus={autoFocus}
      valorInicial={valorInicial}
    />
  );
}
